// extracted by mini-css-extract-plugin
export default {"Jobs__cell":"styles_Jobs__cell__RCCZd","Jobs__cell__content":"styles_Jobs__cell__content__KRLOM"};